var _defs, _path, _path2, _path3, _path4, _ellipse, _ellipse2, _path5, _ellipse3, _ellipse4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGhost(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 402.78 467.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#c1d5d7;}.cls-2{fill:none;stroke:#97a4a5;stroke-linecap:round;stroke-miterlimit:10;stroke-width:5px;}.cls-3{fill:#97a4a5;}.cls-4{fill:#d8eeef;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M85.5,478.79S65.35,35.38,244.51,36.5c164.24,1,182.62,361.57,184.54,421.56a45.12,45.12,0,0,1-7.13,26.26c-6.17,9.39-17,17.74-35.21,11.27C352,483.27,355.92,450.24,333,477.67c-16.38,19.59-51.06,40.43-75.92,4s-51,12.91-62.38,18.9c-25.74,13.52-28.54-16.16-40.29-29C137.15,452.66,132,495,112.05,500.58,93.46,505.77,85.5,499,85.5,478.79Z",
    transform: "translate(-84.82 -36.5)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M-54,428",
    transform: "translate(-84.82 -36.5)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M350.84,221.78s73.91-10.92,96.39-40.05c26.66-34.56,31,21.59,32.09,27.29,2.22,11.87,15.66,46.15,2.75,49.82s-21-12.09-28.61-8.07.16,20.49-2.21,28.21-12.76,14.58-28.15-1.18,13,48.21-23.64,48.59",
    transform: "translate(-84.82 -36.5)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M242.11,270.23S301.93,315,338.45,310.4c43.31-5.43,6.54,37.23,3.25,42-6.86,9.94-21.72,43.64-33.42,37.06s-6.2-23.42-14.44-26S280.31,381,272.28,381.78s-19.55-2.53-19.21-24.55-24.82,47-50.93,21.2",
    transform: "translate(-84.82 -36.5)"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-3",
    cx: 152.4,
    cy: 138.85,
    rx: 20.16,
    ry: 31.91
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-3",
    cx: 237.5,
    cy: 120.93,
    rx: 20.16,
    ry: 31.91
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M253.75,260.3a95.35,95.35,0,0,1,4-15.81,64,64,0,0,1,3.21-7.72,40.51,40.51,0,0,1,4.67-7.44,19.83,19.83,0,0,1,8-6.11,10.24,10.24,0,0,1,1.39-.44,11.16,11.16,0,0,1,1.44-.32,14.26,14.26,0,0,1,3-.17c.5,0,1,0,1.5.12l1.43.29.72.17.67.22,1.33.49,3.77,1.58,3.63,1.48c2.4,1,4.78,1.89,7.11,2.64a30.13,30.13,0,0,0,6.71,1.47,9.49,9.49,0,0,0,4.73-.55,4.64,4.64,0,0,0,1.07-.73,9.65,9.65,0,0,0,1-1.06c.2-.25.41-.49.63-.81l.18-.22.27-.39c.2-.3.41-.59.62-.87.81-1.15,1.75-2.33,2.73-3.49a30.71,30.71,0,0,1,7.79-6.76c.91-.47,1.79-.93,2.74-1.32a19.4,19.4,0,0,1,3-.86,15.81,15.81,0,0,1,6.1,0,19,19,0,0,1,8.93,4.6,28.7,28.7,0,0,1,5.67,6.79.86.86,0,0,1-.88,1.31h-.06c-.73-.11-1.4-.28-2.1-.41s-1.32-.34-2-.45-1.31-.24-2-.36c-.32-.06-.63-.14-.94-.19l-.94-.11a14.08,14.08,0,0,0-6.26.12,6.25,6.25,0,0,0-3.1,2.33,38.73,38.73,0,0,0-3.16,4.78l-1.81,3.08c-.15.26-.31.53-.48.79l-.27.44-.4.6a21.17,21.17,0,0,1-1.79,2.35,19.67,19.67,0,0,1-5,4.11,18.84,18.84,0,0,1-6.31,2.19,24.87,24.87,0,0,1-11.1-1.1,64.48,64.48,0,0,1-8.46-3.45c-2.61-1.24-5.05-2.57-7.44-3.92-1.2-.67-2.37-1.36-3.53-2.05l-3.36-2-.51-.3-.25-.16-.25-.09-.49-.22a4.27,4.27,0,0,0-.48-.13,4.11,4.11,0,0,0-1-.17,2.29,2.29,0,0,0-.52,0,2.13,2.13,0,0,0-.55,0,11.12,11.12,0,0,0-5.07,2.7c-3.49,3-6.47,7.29-9.1,11.72-1.32,2.24-2.55,4.55-3.71,6.92s-2.27,4.78-3.28,7.22v0a.8.8,0,0,1-1,.43A.81.81,0,0,1,253.75,260.3Z",
    transform: "translate(-84.82 -36.5)"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-4",
    cx: 170.24,
    cy: 130.47,
    rx: 48.15,
    ry: 11.76,
    transform: "translate(-104.54 193.58) rotate(-65.14)"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-4",
    cx: 137.03,
    cy: 225.23,
    rx: 25.5,
    ry: 9.31,
    transform: "translate(-195.55 278.86) rotate(-78.68)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGhost);
export default __webpack_public_path__ + "static/media/ghost.0124f4d3.svg";
export { ForwardRef as ReactComponent };